<template>
  <div>
    <h3>Different Hours</h3>
    <div class="row">
      <div class="col-4">
        <div class="form-group">
          <label class="control-label col-md-8"
            >Hours-From</label
          >
          <div class="col-md-8">
            <datepicker
              :clear-button="true"
              v-model="differentHours.from"
              class="text-box single-line"
            />
          </div>
        </div>
      </div>
      <div class="col-4">
        <div class="form-group">
          <label class="control-label col-md-8"
            >Hours-To</label
          >
          <div class="col-md-8">
            <datepicker
              :clear-button="true"
              v-model="differentHours.to"
              class="text-box single-line"
            />
          </div>
        </div>
      </div>
      <div class="col-2">
        <div class="form-group">
          <label class="control-label col-md-8"
            >Hours</label
          >
          <div class="col-md-8">
            <input
              v-model="differentHours.hours"
              class="form-control text-box single-line"
            />
          </div>
        </div>
      </div>
      <div class="col-2">
        <div class="form-group">
          <button
            v-on:click="postDifferentHours"
            type="button"
            class="btn btn-secondary disabled"
          >
            Submit
          </button>
        </div>
      </div>
    </div>
    <div v-if="differentHoursData.length > 0">
      <table class="table">
        <tr>
          <td><b>From</b></td>
          <td><b>To</b></td>
          <td><b>Hours / Week</b></td>
          <td><b>Options</b></td>
        </tr>
        <tbody v-for="e in differentHoursData" :key="e.id">
          <td>{{ moment(e.from).format("yyyy-MM-DD") }}</td>
          <td>{{ moment(e.to).format("yyyy-MM-DD") }}</td>
          <td>{{ e.hours }}</td>
          <td><a class="btn btn-danger" @click="deleteEntry(e.id)">Löschen</a></td>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import datepicker from "vuejs-datepicker";
import moment from "moment";

export default {
  props: ["user"],
  components: {
    datepicker,
  },
  name: "differentHours",
  data: function () {
    return {
      differentHours: {},
      differentHoursData: [],
      moment: moment
    };
  },
  created: function () {},
  methods: {
    postDifferentHours: function () {
      const data = {
        from: moment(this.differentHours.from).format("yyyy-MM-DD"),
        to: moment(this.differentHours.to).format("yyyy-MM-DD"),
        hours: this.differentHours.hours,
        userId: this.user.id,
        createdAt: moment().format("yyyy-MM-DD")
      }
      axios({
        method: "POST",
        url: process.env.VUE_APP_API_PATH + "differentHours",
        data: data,
      }).then(
        (result) => {
          this.differentHoursData = result.data;
          this.getDifferentHours()
        },
        (error) => {
          console.error(error);
          if (error.response.status == 401) {
            this.$router.push("/");
          }
        }
      );
    },
    deleteEntry: function (hourId) {
      axios({ method: "DELETE", "url": process.env.VUE_APP_API_PATH + "differentHours/" + hourId })
          .then(result => {
            var indexToRemove = -1;
            for (var i = 0; i < this.differentHoursData.length; i++) {
              if (this.differentHoursData[i].id == hourId) {
                indexToRemove = i;
              }
            }
            this.differentHoursData.splice(indexToRemove, 1);
          }, error => {
            console.error(error);
          });
    },
    getDifferentHours: function () {
      axios({
        method: "GET",
        url:
          process.env.VUE_APP_API_PATH +
          "differentHours/GetByUser/" +
          this.user.id,
      }).then(
        (result) => {
          this.differentHoursData = result.data;
        },
        (error) => {
          console.error(error);
          if (error.response.status == 401) {
            this.$router.push("/");
          }
        }
      );
    },
  },
  mounted() {
    this.getDifferentHours();
  },
};
</script>